module.exports = __webpack_public_path__ + "static/media/pers-foto-a.57dc8aa8.jpg";